import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';

export const ButtonContainer = styled.div<{
  theme: ICustomTheme;
}>`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing(3)}px;
  margin-top: ${({ theme }) => theme.spacing(3)}px;
`;

export const FormWrapper = styled.div<{
  theme: ICustomTheme;
}>`
  display: flex;
  form {
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: ${({ theme }) => theme.shape.borderRadius * 2.5};
    height: 20rem;
    max-width: 30rem;
    padding: ${({ theme }) => theme.spacing(2.5)}px;
    width: 100%;
    > div {
      width: 100%;
    }
  }
`;

export const InputsContainer = styled.div<{
  theme: ICustomTheme;
}>`
  margin-top: ${({ theme }) => theme.spacing(3.5)}px;
  width: 100%;
  > div {
    width: 100%;
  }
`;

export const LinkContainer = styled.div`
  text-align: center;
`;
